import { ChangeDetectorRef, ElementRef, EventEmitter, SimpleChanges, TemplateRef } from '@angular/core';
import { MessageService } from '../../message/message.service';
import { SessionStorageService } from 'ngx-webstorage';
import { DomSanitizer } from '@angular/platform-browser';
import { TrackerService } from '../../../core/tracker/tracker.service';
import { BaseComponent } from '../../../shared/base.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { JhiLanguageService } from '../../../ng-jhipster/language';
import { JhiEventManager } from '../../../ng-jhipster/service';
import { AccountService } from '../../../core/auth/account.service';
import moment from 'moment';
import { Router } from "@angular/router";
import { SERVER_API_URL } from '../../../app.constants';
import { AuthServerProvider } from '../../../core/auth/auth-jwt.service';
import { ConversationnService } from '../../conversationn/conversationn.service';
import { RatingService } from '../../rating/rating.service';
import { SessionService } from '../../session/session.service';
import { AlertModalComponent } from '../../../shared/alert/alert-modal.component';
import { MessageRepository } from '../../session/chat-ui-new/message.repository';
import { VirtualScrollService } from '../../session/chat-ui-new/virtual-scroll.service';
import { MessageReactionDto } from '../../../shared/model/message-reaction-dto';
import { ExternalVideoCallRedirectPopupComponent } from '../../video-call/external-video-call-redirect-popup/external-video-call-redirect-popup.component';
import { VideoCallService } from '../../video-call/video-call.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/auth/account.service";
import * as i2 from "ngx-webstorage";
import * as i3 from "../../../core/tracker/tracker.service";
import * as i4 from "@ng-bootstrap/ng-bootstrap";
import * as i5 from "../../../ng-jhipster/language";
import * as i6 from "../../../core/auth/auth-jwt.service";
import * as i7 from "../../message/message.service";
import * as i8 from "../../../ng-jhipster/service";
import * as i9 from "@angular/platform-browser";
import * as i10 from "@angular/router";
import * as i11 from "../../conversationn/conversationn.service";
import * as i12 from "../../rating/rating.service";
import * as i13 from "../../session/session.service";
import * as i14 from "../../video-call/video-call.service";
import * as i15 from "@angular/common";
import * as i16 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i17 from "ngx-ui-scroll";
import * as i18 from "../../../shared/auto-direction-switch/auto-direction-switch/auto-direction-switch.component";
import * as i19 from "@fortawesome/angular-fontawesome";
import * as i20 from "../message-reaction/message-reaction-selector/message-reaction-selector.component";
import * as i21 from "../../user-interaction/consent-to-share-organization-resource/consent-to-share-organization-resource.component";
import * as i22 from "../../organization-resources/organization-resources.component";
import * as i23 from "@ngx-translate/core";
const _c0 = ["messagesContainer"];
const _c1 = ["messageBox"];
const _c2 = ["virtualScrollViewPort"];
const _c3 = ["messageElement"];
const _c4 = ["consentToShareOrganizationResourcesModal"];
function ChatUiNewComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵtext(1, " Loading... ");
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10, 11);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.showDateBetweenNow(ctx_r2.firstVisibleMessage), " ");
} }
function ChatUiNewComponent_div_4_div_3_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "hr", 24);
    i0.ɵɵelementStart(2, "div");
    i0.ɵɵelement(3, "span", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelement(1, "hr", 24);
    i0.ɵɵelement(2, "span", 26);
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelement(2, "auto-direction-switch", 28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", m_r13.message, i0.ɵɵsanitizeHtml)("applyAlignment", false)("isAutomatedMessage", m_r13.type === "automatedMessage");
} }
function ChatUiNewComponent_div_4_div_3_div_10_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r27 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r27.session.user.login);
} }
const _c5 = function (a1) { return ["/session/book-follow-up", a1]; };
function ChatUiNewComponent_div_4_div_3_div_10_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 32);
} if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("routerLink", i0.ɵɵpureFunction1(1, _c5, ctx_r28.session.id));
} }
function ChatUiNewComponent_div_4_div_3_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "span", 29);
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_10_span_2_Template, 2, 1, "span", 30);
    i0.ɵɵtemplate(3, ChatUiNewComponent_div_4_div_3_div_10_span_3_Template, 1, 3, "span", 31);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("jhiTranslate", m_r13.message);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.message === "inukaNgApp.session.actionPlanWasSharedWith");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.message === "inukaNgApp.offlineMessage.sessionEnded");
} }
function ChatUiNewComponent_div_4_div_3_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "button", 33);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_11_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r32); const m_r13 = i0.ɵɵnextContext().$implicit; const ctx_r30 = i0.ɵɵnextContext(2); return ctx_r30.showExternalVideoCallPopup(m_r13.message); });
    i0.ɵɵtext(3, "Join Video Call");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "span", 29);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("jhiTranslate", "sessionChat.messages." + m_r13.message);
} }
function ChatUiNewComponent_div_4_div_3_div_13_Template(rf, ctx) { if (rf & 1) {
    const _r35 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "span", 34);
    i0.ɵɵelementStart(2, "span", 35);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_13_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r35); const ctx_r34 = i0.ɵɵnextContext(3); const _r8 = i0.ɵɵreference(10); return ctx_r34.openOrganizationResourcesModal(_r8); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 36);
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 27);
    i0.ɵɵelement(1, "span", 37);
    i0.ɵɵelement(2, "a", 38);
    i0.ɵɵelement(3, "span", 39);
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_2_div_1_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 62);
} }
const _c6 = function (a0) { return { "background": a0 }; };
function ChatUiNewComponent_div_4_div_3_div_15_div_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r55 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_2_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r55); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r53 = i0.ɵɵnextContext(2); return ctx_r53.addToMessagesEmail(m_r13, ctx_r53.isCoachAccount); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_2_div_1_fa_icon_2_Template, 1, 0, "fa-icon", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "inukaNgApp.offlineMessage.selected"));
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c6, m_r13.chosenToBeEmailed ? "#44A38B" : "white"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", m_r13.chosenToBeEmailed);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 63);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_2_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r59); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r57 = i0.ɵɵnextContext(2); return ctx_r57.replyThisMessage(m_r13); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelement(2, "fa-icon", 64);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 1, "inukaNgApp.offlineMessage.reply"));
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 57);
    i0.ɵɵtemplate(1, ChatUiNewComponent_div_4_div_3_div_15_div_2_div_1_Template, 3, 7, "div", 58);
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_2_div_2_Template, 3, 3, "div", 59);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r36 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.isCoachAccount && (ctx_r36.isVisible === m_r13.id || ctx_r36.isVisibleMobile === m_r13.id || m_r13.chosenToBeEmailed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r36.isVisible === m_r13.id || ctx_r36.isVisibleMobile === m_r13.id);
} }
function ChatUiNewComponent_div_4_div_3_div_15_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 65);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r37 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", m_r13.senderId === ctx_r37.session.user.id ? ctx_r37.session.user.login + ": " : ctx_r37.session.coach.login + ": ", " ");
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_5_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r66 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_5_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r66); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r64 = i0.ɵɵnextContext(2); return ctx_r64.scrollToOriginal(m_r13.replyId); });
    i0.ɵɵelementStart(1, "a", 70);
    i0.ɵɵelement(2, "img", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelement(5, "auto-direction-switch", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r62 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", ctx_r62.getMediaDownloadUrl(m_r13.replyMessage), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("src", ctx_r62.getMediaDownloadUrl(m_r13.replyMessage), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", ctx_r62.getImageCaption(m_r13.replyMessage), i0.ɵɵsanitizeHtml);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_5_div_2_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 77);
    i0.ɵɵtext(1, "...");
    i0.ɵɵelementEnd();
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_5_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 73);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_5_div_2_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r72); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r70 = i0.ɵɵnextContext(2); return ctx_r70.scrollToOriginal(m_r13.replyId); });
    i0.ɵɵelementStart(1, "div", 74, 75);
    i0.ɵɵelement(3, "auto-direction-switch", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ChatUiNewComponent_div_4_div_3_div_15_div_5_div_2_div_4_Template, 2, 0, "div", 76);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r68 = i0.ɵɵreference(2);
    const m_r13 = i0.ɵɵnextContext(3).$implicit;
    const ctx_r63 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", m_r13.replyMessage.message, i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r63.checkOverflow(_r68));
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵtemplate(1, ChatUiNewComponent_div_4_div_3_div_15_div_5_div_1_Template, 6, 3, "div", 67);
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_5_div_2_Template, 5, 2, "div", 68);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("ngSwitch", m_r13.replyMessage.type);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "image");
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "audio", 78);
    i0.ɵɵelement(2, "source", 79);
    i0.ɵɵtext(3, " Your browser does not support the audio element. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r40 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("src", ctx_r40.getMediaDownloadUrl(m_r13), i0.ɵɵsanitizeUrl);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "a", 80);
    i0.ɵɵelement(2, "img", 71);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "br");
    i0.ɵɵelementStart(4, "span");
    i0.ɵɵelement(5, "auto-direction-switch", 72);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r41 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("href", ctx_r41.getMediaDownloadUrl(m_r13), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("src", ctx_r41.getMediaDownloadUrl(m_r13), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("innerHtml", ctx_r41.getImageCaption(m_r13), i0.ɵɵsanitizeHtml);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 81);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 81);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 81);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 81);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 81);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_15_img_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "img", 86);
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵproperty("src", "../../../../../../../../../content/images/chat/" + m_r13.status + ".png", i0.ɵɵsanitizeUrl);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "span", 82);
    i0.ɵɵelement(2, "auto-direction-switch", 83);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelementStart(4, "span", 84);
    i0.ɵɵtext(5);
    i0.ɵɵtemplate(6, ChatUiNewComponent_div_4_div_3_div_15_div_15_img_6_Template, 1, 1, "img", 85);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r47 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHtml", m_r13.message, i0.ɵɵsanitizeHtml)("isAutomatedMessage", m_r13.type === "automatedMessage");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", m_r13.createDate.format("hh:mm a").toUpperCase(), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !ctx_r47.displayTranscriptions && m_r13.status && m_r13.senderId === ctx_r47.loggedInUserId);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div");
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_23_div_1_fa_icon_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "fa-icon", 62);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_23_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r85 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_23_div_1_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r85); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r83 = i0.ɵɵnextContext(2); return ctx_r83.addToMessagesEmail(m_r13, ctx_r83.isCoachAccount); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_23_div_1_fa_icon_2_Template, 1, 0, "fa-icon", 61);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(3).$implicit;
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(1, 3, "inukaNgApp.offlineMessage.selected"));
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(5, _c6, m_r13.chosenToBeEmailed ? "#44A38B" : "white"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", m_r13.chosenToBeEmailed);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_message_reaction_selector_4_Template(rf, ctx) { if (rf & 1) {
    const _r90 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "message-reaction-selector", 90);
    i0.ɵɵlistener("onReactionSelected", function ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_message_reaction_selector_4_Template_message_reaction_selector_onReactionSelected_0_listener($event) { i0.ɵɵrestoreView(_r90); const m_r13 = i0.ɵɵnextContext(4).$implicit; const ctx_r88 = i0.ɵɵnextContext(2); return ctx_r88.updateMessageReaction(m_r13, $event); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(4).$implicit;
    i0.ɵɵproperty("message", m_r13);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r94 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 88);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r94); const m_r13 = i0.ɵɵnextContext(3).$implicit; const ctx_r92 = i0.ɵɵnextContext(2); return ctx_r92.replyThisMessage(m_r13); });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelement(3, "fa-icon", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_message_reaction_selector_4_Template, 1, 1, "message-reaction-selector", 89);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r81 = i0.ɵɵnextContext(5);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind1(2, 2, "inukaNgApp.offlineMessage.reply"));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r81.isMessageReactionsEnabled);
} }
function ChatUiNewComponent_div_4_div_3_div_15_div_23_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "div", 87);
    i0.ɵɵtemplate(1, ChatUiNewComponent_div_4_div_3_div_15_div_23_div_1_Template, 3, 7, "div", 58);
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_23_ng_container_2_Template, 5, 4, "ng-container", 30);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.isCoachAccount && (ctx_r49.isVisible === m_r13.id || ctx_r49.isVisibleMobile === m_r13.id || m_r13.chosenToBeEmailed));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r49.isVisible === m_r13.id || ctx_r49.isVisibleMobile === m_r13.id);
} }
function ChatUiNewComponent_div_4_div_3_div_15_Template(rf, ctx) { if (rf & 1) {
    const _r97 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("mouseenter", function ChatUiNewComponent_div_4_div_3_div_15_Template_div_mouseenter_0_listener() { i0.ɵɵrestoreView(_r97); const m_r13 = i0.ɵɵnextContext().$implicit; const ctx_r96 = i0.ɵɵnextContext(2); return ctx_r96.isVisible = m_r13.id; })("mouseleave", function ChatUiNewComponent_div_4_div_3_div_15_Template_div_mouseleave_0_listener() { i0.ɵɵrestoreView(_r97); const ctx_r99 = i0.ɵɵnextContext(3); return ctx_r99.isVisible = -1; });
    i0.ɵɵelementStart(1, "div", 41);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_Template_div_click_1_listener() { i0.ɵɵrestoreView(_r97); const m_r13 = i0.ɵɵnextContext().$implicit; const ctx_r100 = i0.ɵɵnextContext(2); return ctx_r100.toggleVisible(m_r13.id); });
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_4_div_3_div_15_div_2_Template, 3, 2, "div", 42);
    i0.ɵɵelementStart(3, "div", 43);
    i0.ɵɵtemplate(4, ChatUiNewComponent_div_4_div_3_div_15_span_4_Template, 2, 1, "span", 44);
    i0.ɵɵtemplate(5, ChatUiNewComponent_div_4_div_3_div_15_div_5_Template, 3, 2, "div", 45);
    i0.ɵɵelementStart(6, "div", 46, 47);
    i0.ɵɵtemplate(8, ChatUiNewComponent_div_4_div_3_div_15_div_8_Template, 4, 1, "div", 48);
    i0.ɵɵtemplate(9, ChatUiNewComponent_div_4_div_3_div_15_div_9_Template, 6, 3, "div", 48);
    i0.ɵɵtemplate(10, ChatUiNewComponent_div_4_div_3_div_15_div_10_Template, 1, 0, "div", 49);
    i0.ɵɵtemplate(11, ChatUiNewComponent_div_4_div_3_div_15_div_11_Template, 1, 0, "div", 49);
    i0.ɵɵtemplate(12, ChatUiNewComponent_div_4_div_3_div_15_div_12_Template, 1, 0, "div", 49);
    i0.ɵɵtemplate(13, ChatUiNewComponent_div_4_div_3_div_15_div_13_Template, 1, 0, "div", 49);
    i0.ɵɵtemplate(14, ChatUiNewComponent_div_4_div_3_div_15_div_14_Template, 1, 0, "div", 49);
    i0.ɵɵtemplate(15, ChatUiNewComponent_div_4_div_3_div_15_div_15_Template, 7, 4, "div", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, ChatUiNewComponent_div_4_div_3_div_15_div_16_Template, 1, 0, "div", 30);
    i0.ɵɵelementStart(17, "div", 51);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_4_div_3_div_15_Template_div_click_17_listener() { i0.ɵɵrestoreView(_r97); const m_r13 = i0.ɵɵnextContext().$implicit; const ctx_r102 = i0.ɵɵnextContext(2); return ctx_r102.removeMessageReaction(m_r13); });
    i0.ɵɵelementStart(18, "span", 52);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "span", 53);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(21, "svg", 54);
    i0.ɵɵelement(22, "use", 55);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(23, ChatUiNewComponent_div_4_div_3_div_15_div_23_Template, 3, 2, "div", 56);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r104 = i0.ɵɵnextContext();
    const m_r13 = ctx_r104.$implicit;
    const i_r14 = ctx_r104.index;
    const ctx_r25 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate("id", m_r13.id);
    i0.ɵɵproperty("ngClass", ctx_r25.getMessageColor(m_r13));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r25.displayTranscriptions && m_r13.senderId === (ctx_r25.currentAccount == null ? null : ctx_r25.currentAccount.id));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r25.isMastermind() || ctx_r25.isSupervisor());
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.replyMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵpropertyInterpolate1("id", "message-", i_r14, "");
    i0.ɵɵproperty("ngSwitch", m_r13.type);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngSwitchCase", "audio");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "image");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "textNotification");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "htmlNotification");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "userInteractionStarted");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "userInteractionFinished");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngSwitchCase", "videoLink");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r25.isFirstSessionMessage(m_r13, i_r14));
    i0.ɵɵadvance(1);
    i0.ɵɵclassProp("message-reaction", m_r13.receiverReaction);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", m_r13.receiverReaction, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r25.displayTranscriptions && !(m_r13.senderId === ctx_r25.loggedInUserId));
} }
function ChatUiNewComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 15);
    i0.ɵɵelementStart(2, "div", 16, 17);
    i0.ɵɵtemplate(4, ChatUiNewComponent_div_4_div_3_div_4_Template, 4, 0, "div", 18);
    i0.ɵɵtemplate(5, ChatUiNewComponent_div_4_div_3_div_5_Template, 3, 0, "div", 18);
    i0.ɵɵelementStart(6, "div", 19);
    i0.ɵɵelementStart(7, "div", 20);
    i0.ɵɵtext(8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, ChatUiNewComponent_div_4_div_3_div_9_Template, 3, 3, "div", 21);
    i0.ɵɵtemplate(10, ChatUiNewComponent_div_4_div_3_div_10_Template, 4, 3, "div", 21);
    i0.ɵɵtemplate(11, ChatUiNewComponent_div_4_div_3_div_11_Template, 4, 0, "div", 21);
    i0.ɵɵtemplate(12, ChatUiNewComponent_div_4_div_3_div_12_Template, 2, 1, "div", 21);
    i0.ɵɵtemplate(13, ChatUiNewComponent_div_4_div_3_div_13_Template, 4, 0, "div", 21);
    i0.ɵɵtemplate(14, ChatUiNewComponent_div_4_div_3_div_14_Template, 4, 0, "div", 21);
    i0.ɵɵtemplate(15, ChatUiNewComponent_div_4_div_3_div_15_Template, 24, 19, "div", 22);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const m_r13 = ctx.$implicit;
    const i_r14 = ctx.index;
    const ctx_r12 = i0.ɵɵnextContext(2);
    let tmp_3_0;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(13, _c6, m_r13.chosenToBeEmailed ? "#FCFBF7" : "white"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", m_r13.isLastSessionMessage);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.isFirstSessionMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("v-hidden", (ctx_r12.firstVisibleMessage == null ? null : ctx_r12.firstVisibleMessage.createDate.isSame(m_r13.createDate, "day")) || ((tmp_3_0 = ctx_r12.virtualScroll.getPreviousVisible(i_r14)) == null ? null : tmp_3_0.createDate.isSame(m_r13.createDate, "day")));
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.showDateBetweenNow(m_r13), " ");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.type === "htmlNotification");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.session != null && m_r13.type === "textNotification");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.type === "videoLink");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.type === "userInteractionStarted" && ctx_r12.isCoachAccount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.type === "userInteractionFinished" && ctx_r12.isCoachAccount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", m_r13.type === "userInteractionFinished" && ctx_r12.isUserAccount);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !(m_r13.type === "textNotification" || m_r13.type === "htmlNotification" || m_r13.type === "userInteractionStarted" || m_r13.type === "userInteractionFinished" || m_r13.type === "videoLink"));
} }
const _c7 = function (a0) { return { height: a0 }; };
function ChatUiNewComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", null, 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵtemplate(3, ChatUiNewComponent_div_4_div_3_Template, 16, 15, "div", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const _r11 = i0.ɵɵreference(1);
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("height", ctx_r3.viewportHeight);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(4, _c7, _r11.offsetHeight - 10 + "px"));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("uiScrollOf", ctx_r3.virtualScroll.dataSource);
} }
const _c8 = function (a0) { return { count: a0 }; };
function ChatUiNewComponent_div_5_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 98);
} if (rf & 2) {
    const ctx_r105 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c8, ctx_r105.messagesList.length));
} }
function ChatUiNewComponent_div_5_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 99);
} if (rf & 2) {
    const ctx_r106 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction1(1, _c8, ctx_r106.messagesList.length));
} }
function ChatUiNewComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r108 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 91);
    i0.ɵɵtemplate(1, ChatUiNewComponent_div_5_span_1_Template, 1, 3, "span", 92);
    i0.ɵɵtemplate(2, ChatUiNewComponent_div_5_span_2_Template, 1, 3, "span", 93);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(3, "svg", 94);
    i0.ɵɵelement(4, "use", 95);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(5, "span", 96);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_5_Template_span_click_5_listener() { i0.ɵɵrestoreView(_r108); const ctx_r107 = i0.ɵɵnextContext(); return ctx_r107.emailSelectedMessages(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "fa-icon", 97);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_5_Template_fa_icon_click_6_listener() { i0.ɵɵrestoreView(_r108); const ctx_r109 = i0.ɵɵnextContext(); return ctx_r109.emptyMessagesList(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.messagesList.length === 1);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.messagesList.length !== 1);
} }
function ChatUiNewComponent_div_6_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(0, "span", 105);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r110 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r110.unreadMessageCount);
} }
function ChatUiNewComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r112 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 100);
    i0.ɵɵelementStart(1, "button", 101);
    i0.ɵɵlistener("click", function ChatUiNewComponent_div_6_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r112); const ctx_r111 = i0.ɵɵnextContext(); return ctx_r111.scrollToBottom(); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(2, "svg", 102);
    i0.ɵɵelement(3, "use", 103);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ChatUiNewComponent_div_6_span_4_Template, 2, 1, "span", 104);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r5.unreadMessageCount > 0);
} }
function ChatUiNewComponent_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    const _r115 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 106);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵelementStart(2, "fa-icon", 108);
    i0.ɵɵlistener("click", function ChatUiNewComponent_ng_template_7_Template_fa_icon_click_2_listener() { i0.ɵɵrestoreView(_r115); const ctx_r114 = i0.ɵɵnextContext(); return ctx_r114.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 109);
    i0.ɵɵelementStart(4, "div", 110);
    i0.ɵɵelement(5, "consent-to-share-organization-resource", 111);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("userId", ctx_r7.userId)("isRequest", true);
} }
function ChatUiNewComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    const _r118 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 106);
    i0.ɵɵelementStart(1, "div", 107);
    i0.ɵɵelementStart(2, "fa-icon", 108);
    i0.ɵɵlistener("click", function ChatUiNewComponent_ng_template_9_Template_fa_icon_click_2_listener() { const restoredCtx = i0.ɵɵrestoreView(_r118); const modal_r116 = restoredCtx.$implicit; return modal_r116.close("close"); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 109);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵelement(5, "organization-resources", 112);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("userId", ctx_r9.userId)("isPopup", true);
} }
export class BaseChatUIComponent extends BaseComponent {
    constructor(accountService, sessionStorage, trackerService, modalService, languageService) {
        super(sessionStorage, modalService);
        this.accountService = accountService;
        this.sessionStorage = sessionStorage;
        this.trackerService = trackerService;
        this.modalService = modalService;
        this.languageService = languageService;
        this.scrolledToBottom = new EventEmitter();
        this.unreadMessageCountChange = new EventEmitter();
        this.isUserAccount = false;
        this.isCoachAccount = false;
        this.unreadMessageCount = 0;
        this.hasHiddenMessages = false;
        this.autoScrollingToBottom = false;
        this.isVisible = -1;
        this.isVisibleMobile = -1;
        this.visibleComponent = "ChatUiNewComponent";
        this.isUserAccount = this.accountService.isUser();
        this.isCoachAccount = this.accountService.isCoach();
        this.subscribeToWebsocket();
    }
    subscribeToWebsocket() {
        this.subscription = this.trackerService.listenerSubject.subscribe(value => {
            const body = value['body'];
            const type = value['type'];
            if (type === 'TYPING') {
            }
            else if (type === 'MESSAGE_SEEN') {
                this.updateMessageStatus(body);
            }
            else if (type === 'SESSION_MESSAGE' && !this.ignoreNewReceivedMessages) {
                // console.log('SESSION_MESSAGE received');
                this.onMessageReceived(body);
            }
            else if (type === 'OFFLINE_MESSAGE_RECEIVED' && !this.ignoreNewReceivedMessages) {
                // console.log('SESSION_MESSAGE received');
                this.onMessageReceived(body);
            }
            else if (type === 'MESSAGE_REACTION_UPDATED' && !this.ignoreNewReceivedMessages) {
                // console.log('SESSION_MESSAGE received');
                this.onMessageReactionUpdated(body);
            }
            else {
                console.log('ChatUIComponent ignoring ' + type + ' message');
            }
        });
    }
    isMastermind() {
        return this.accountService.isMastermind();
    }
    isSupervisor() {
        return this.accountService.isSupervisor();
    }
    isCoach() {
        return this.accountService.isCoach();
    }
    isUser() {
        return this.accountService.isUser();
    }
    sentByCurrentUser(userId) {
        // TODO called by chat-ui, consider switching to field access to improve performance
        return userId === this.loggedInUserId;
    }
    scrollToBottom() {
        // setTimeout(() => {
        //   // this.viewport.scrollToIndex(this.messages.length - 1);
        //   const items = document.getElementsByClassName("message-time");
        //   if (items != null && items.length >= 1 && items[items.length - 1] != null) {
        //     setTimeout(() => {
        //       items[items.length - 1].scrollIntoView({behavior: "auto"});
        //       this.unreadMessageCount = 0;
        //       this.scrolledToBottom.emit({ userId: this.userId, coachId: this.coachId, unreadMessageCount: 0 });
        //     }, 100);
        //   }
        // }, 100);
    }
    showDateBetweenNow(m) {
        let valueOfDay = moment(m.createDate).locale(this.languageService.getCurrentLanguage())
            .calendar(null, {
            lastWeek: 'dddd',
            sameElse: 'DD-MM-YYYY',
        }); // there are no option for sameDay and lastDay to format just 'Day'. that mean this will show like 'today PM 10:25'
        return valueOfDay.substr(0, valueOfDay.includes(' ') ? valueOfDay.indexOf(' ') : valueOfDay.length); // slice for HOUR format and handle indexOf() error by include()
    }
    getImageCaption(m) {
        return m.message != null && m.message.includes(' ') ? m.message.substring(m.message.indexOf(' ')) : "";
    }
    makeVisible(id) {
        this.isVisible = id;
    }
    makeHidden() {
        this.isVisible = -1;
    }
    toggleVisible(id) {
        if (this.windowWidth < 576)
            this.isVisibleMobile = this.isVisibleMobile === -1 ? id : -1;
    }
    openRateSession() {
    }
    cdkScrollToBottom() {
        // setTimeout(() => {
        //   this.viewport.scrollTo({
        //     bottom: 0,
        //     behavior: 'auto',
        //   });
        // }, 0);
        // setTimeout(() => {
        //   this.viewport.scrollTo({
        //     bottom: 0,
        //     behavior: 'auto',
        //   });
        // }, 100);
        // if (this.topDate) this.showCurrentDate();
        // this.scrolledToBottom.emit({ userId: this.userId, coachId: this.coachId, unreadMessageCount: 0 });
    }
}
BaseChatUIComponent.ɵfac = function BaseChatUIComponent_Factory(t) { return new (t || BaseChatUIComponent)(i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.SessionStorageService), i0.ɵɵdirectiveInject(i3.TrackerService), i0.ɵɵdirectiveInject(i4.NgbModal), i0.ɵɵdirectiveInject(i5.JhiLanguageService)); };
BaseChatUIComponent.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: BaseChatUIComponent, viewQuery: function BaseChatUIComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
        i0.ɵɵviewQuery(_c2, 5);
        i0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageBox = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.viewport = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.messageElement = _t.first);
    } }, inputs: { ignoreNewReceivedMessages: "ignoreNewReceivedMessages" }, outputs: { scrolledToBottom: "scrolledToBottom", unreadMessageCountChange: "unreadMessageCountChange" }, features: [i0.ɵɵInheritDefinitionFeature] });
export class ChatUiNewComponent extends BaseChatUIComponent {
    constructor(authServerProvider, messageService, eventManager, trackerService, sanitizer, accountService, sessionStorage, modalService, languageService, router, conversationnService, ratingService, sessionService, changeDetector, videoCallService) {
        super(accountService, sessionStorage, trackerService, modalService, languageService);
        this.authServerProvider = authServerProvider;
        this.messageService = messageService;
        this.eventManager = eventManager;
        this.trackerService = trackerService;
        this.sanitizer = sanitizer;
        this.accountService = accountService;
        this.sessionStorage = sessionStorage;
        this.modalService = modalService;
        this.languageService = languageService;
        this.router = router;
        this.conversationnService = conversationnService;
        this.ratingService = ratingService;
        this.sessionService = sessionService;
        this.changeDetector = changeDetector;
        this.videoCallService = videoCallService;
        this.displayTranscriptions = false;
        this.repliedMessage = new EventEmitter();
        this.firstSessionMessageOutput = new EventEmitter();
        this.isInbox = this.router.url.includes('inbox');
        this.firstSessionMessage = null;
        this.firstSessionIndex = null;
        this.isKeyPressed = false;
        this.messageReceivedAudio = new Audio("../../../../../../../content/audio/appointed.mp3");
        this.modalOptions = { windowClass: 'modal-window', size: 'md', centered: true };
        this.nonNotificationMessages = ['text', 'image', 'video', 'automatedMessage'];
        this.emptyLine = '<br>'; // ENTER
        this.eventManagerSubscription = this.eventManager.subscribe('update-chat-ui-component-size', () => {
            this.updateSize();
        });
    }
    ngOnInit() {
        this.setCurrentAccount();
        this.url = this.router.url;
        if (this.session != null && this.session.id != null) {
            this.userId = this.session.user.id;
            this.coachId = this.session.coachId;
            this.checkVideoCallStatus(this.session);
        }
        this.eventManager.subscribe('collapsedModeEnabled', () => {
            this.scrollToBottom();
        });
        this.eventManager.subscribe('collapsedModeDisabled', () => {
            this.scrollToBottom();
        });
        this.eventManager.subscribe('userInteractionStartedForConsentToShareOrganizationResource', () => {
            if (this.isUserAccount) {
                this.openOrganizationResourcesModal(this.consentToShareOrganizationResourcesModal);
            }
        });
    }
    checkVideoCallStatus(session) {
        this.isVideoCallInProgressHttpCallSubscription = this.videoCallService.isVideoCallInProgress(session).subscribe(result => {
            this.isVideoCallInProgress = result.body;
        });
    }
    openOrganizationResourcesModal(modal) {
        if (!this.consentPopupIsOn) {
            this.modalService.open(modal, { size: "lg", centered: true, backdrop: "static" });
            this.consentPopupIsOn = true;
        }
    }
    close() {
        this.modalService.dismissAll();
        this.consentPopupIsOn = false;
    }
    ngAfterContentInit() {
        super.ngAfterContentInit();
    }
    ngAfterViewInit() {
    }
    scrollToBottom() {
        this.virtualScroll.scrollToBottom().then(value => {
            this.changeDetector.detectChanges();
        });
    }
    ngOnChanges(changes) {
        var _a;
        let messageRepository;
        if (((_a = changes.session) === null || _a === void 0 ? void 0 : _a.currentValue) != null) {
            this.updatedSession = changes.session.currentValue;
            this.updatedSession.coachId = changes.session.currentValue.coachId;
            this.userId = this.updatedSession.user.id;
            this.coachId = this.updatedSession.coachId;
            this.toggleMessageReactions(this.updatedSession.user);
            if (this.displayingPastSession || this.displayTranscriptions) {
                messageRepository = MessageRepository.createSessionMessageRepository(this.messageService, this.updatedSession.id, this.displayTranscriptions);
            }
            if (this.isCoachAccount) {
                this.conversationnService.getConversationByUserId(this.updatedSession.user.id).subscribe(res => {
                    this.selectedConversation = res.body;
                });
            }
            else {
                this.conversationnService.getConversationByUserId(this.updatedSession.coachId).subscribe(res => {
                    this.selectedConversation = res.body;
                });
            }
            this.checkVideoCallStatus(this.session);
        }
        else {
            if (this.selectedConversation != null && this.selectedConversation.id != null) {
                this.userId = this.selectedConversation.user.id;
                this.coachId = this.selectedConversation.coach.id;
            }
            else {
                console.log("No selected conversation is found.");
            }
            if (this.session != null && this.session.id != null) {
                this.userId = this.session.user.id;
                this.coachId = this.session.coachId;
                this.toggleMessageReactions(this.session.user);
                this.checkVideoCallStatus(this.session);
            }
        }
        if (!messageRepository && this.userId && this.coachId) {
            messageRepository = MessageRepository.createConversationMessageRepository(this.messageService, this.userId, this.coachId);
        }
        if (messageRepository) {
            this.initMessageRepository(messageRepository);
        }
    }
    toggleMessageReactions(coachee) {
        if (coachee && coachee.whatsappConversationId) {
            this.isMessageReactionsEnabled = false;
        }
        else {
            this.isMessageReactionsEnabled = true;
        }
    }
    initMessageRepository(messageLoader) {
        if (this.messageRepository) {
            this.messageRepository.dispose();
        }
        this.messageRepository = messageLoader;
        messageLoader.init().subscribe(result => {
            this.onFirstMessagesLoadCompleted(messageLoader, result);
        });
        messageLoader.onDataFetch$.subscribe(isFetchingMessages => {
            this.isFetchingMessages = isFetchingMessages;
        });
    }
    onFirstMessagesLoadCompleted(messageRepository, messagesList) {
        if (this.virtualScroll) {
            // make sure the existing virtualScroll will be disposed
            this.virtualScroll = null;
            this.changeDetector.detectChanges();
            this.initVirtualScroll(messageRepository);
        }
        else {
            this.initVirtualScroll(messageRepository);
        }
        if (!this.displayTranscriptions) {
            this.markMessagesAsDisplayed();
            this.emitFirstSessionMessage(messagesList.messages);
        }
        this.scrolledToBottom.emit({ userId: this.userId, coachId: this.coachId, unreadMessageCount: 0 });
    }
    initVirtualScroll(messageRepository) {
        this.virtualScroll = VirtualScrollService.create(messageRepository);
        this.virtualScroll.haveHiddenItem.subscribe(value => this.hasHiddenMessages = value);
        this.virtualScroll.getFirstVisibleObservable().subscribe(value => {
            this.firstVisibleMessage = value;
        });
        this.virtualScroll.isLastVisibleObservable().subscribe(value => {
            if (value) {
                this.unreadMessageCount = 0;
                this.unreadMessageCountChange.emit(this.unreadMessageCount);
            }
        });
    }
    addToMessagesEmail(m, isCoach) {
        if (!isCoach) {
            console.log('Clients can not email chat messages');
            return;
        }
        m.chosenToBeEmailed = !m.chosenToBeEmailed;
        if (this.messagesList == null) {
            this.messagesList = [];
        }
        m.chosenToBeEmailed ? this.messagesList.push(m) : this.messagesList.splice(this.messagesList.indexOf(m), 1);
        console.log(this.messagesList);
        this.eventManager.broadcast({ name: 'messagesList', content: this.messagesList });
    }
    getMediaDownloadUrl(message) {
        const authToken = this.authServerProvider.getToken();
        const url = SERVER_API_URL + "api/util/download/message?id=" + message.id + '&access_token=' + authToken;
        return url.substring(0, url.includes(' ') ? url.indexOf(' ') : url.length);
    }
    emailSelectedMessages() {
        this.messagesList.sort((a, b) => a.id - b.id);
        console.log(this.messagesList);
        this.messageService.emailSessionMessages(this.userId, this.messagesList).subscribe((response) => {
            console.log(response);
            if (response.ok) {
                this.openAlertModal('sessionChat.messages.selectedMessagesSuccess');
                this.emptyMessagesList();
            }
        }, (error) => {
            console.log(error);
            this.openAlertModal('sessionChat.messages.selectedMessagesFail');
        });
    }
    emptyMessagesList() {
        for (let i = 0; i < this.messagesList.length; i++) {
            this.messagesList[i].chosenToBeEmailed = false;
        }
        this.messagesList = [];
    }
    openAlertModal(message) {
        const modalRef = this.modalService.open(AlertModalComponent, this.modalOptions);
        modalRef.componentInstance.alertModalRef = modalRef;
        modalRef.componentInstance.language = this.languageService.getCurrentLanguage();
        modalRef.componentInstance.userAlertMessage = message;
    }
    replyThisMessage(m) {
        console.log(m);
        this.repliedMessage.emit(JSON.parse(JSON.stringify(m)));
    }
    scrollToOriginal(id) {
        document.getElementById(String(id)).scrollIntoView();
    }
    // emptyLine2 = '<div><br></div>'; // SHIFT + ENTER
    trim(innerHTML) {
        innerHTML = innerHTML.trim();
        while (innerHTML.endsWith(this.emptyLine)) {
            //
            innerHTML = innerHTML.replace(/<br>$/, '');
        }
        return innerHTML;
    }
    getStateHtml(message) {
        return this.sanitizer.bypassSecurityTrustHtml(message);
    }
    sentByCurrentUser(userId) {
        var _a;
        return userId === ((_a = this.currentAccount) === null || _a === void 0 ? void 0 : _a.id);
    }
    setCurrentAccount() {
        this.authenticatedUserSubscription = this.accountService.getAuthenticationState().subscribe(account => {
            this.currentAccount = account;
        });
    }
    emitFirstSessionMessage(messages) {
        if (messages) {
            let sessionMessages = messages.filter(message => message.sessionId != null);
            if (sessionMessages === null || sessionMessages === void 0 ? void 0 : sessionMessages.length) {
                let lastSessionMessage = sessionMessages[sessionMessages.length - 1];
                this.firstSessionMessageOutput.emit(lastSessionMessage);
            }
        }
    }
    markMessagesAsDisplayed() {
        this.messageService.setMessagesByUserIdAndCoachIdAsDisplayed(this.updatedSession.user.id, this.updatedSession.coachId).subscribe(res => {
            console.log(res);
        });
    }
    onMessageReceived(message) {
        var _a, _b, _c, _d, _e;
        if (this.displayTranscriptions && message.type !== 'transcription') {
            return;
        }
        if (!this.displayTranscriptions && message.type === 'transcription') {
            return;
        }
        let isSameConversation = this.selectedConversation.id === message.convId;
        let belongsSelectedConversation = (((_a = this.selectedConversation) === null || _a === void 0 ? void 0 : _a.coach.id) === message.senderId && ((_b = this.selectedConversation) === null || _b === void 0 ? void 0 : _b.user.id) === message.receiverId) ||
            (((_c = this.selectedConversation) === null || _c === void 0 ? void 0 : _c.user.id) === message.senderId && ((_d = this.selectedConversation) === null || _d === void 0 ? void 0 : _d.coach.id) === message.receiverId);
        // console.log('onMessageReceived: ' + JSON.stringify(message) + '\n session: ' + JSON.stringify(this.session) + "\n selected conversation: " + JSON.stringify(this.selectedConversation));
        if (!((this.selectedConversation && belongsSelectedConversation) || (!this.selectedConversation && ((_e = this.session) === null || _e === void 0 ? void 0 : _e.id) === message.sessionId))) {
            console.log("message belongs to different chat");
            return;
        }
        this.initCreateDate(message);
        this.virtualScroll.appendNewMessage(message, !this.hasHiddenMessages).then();
        // this.messages.push(message);
        if (!this.displayTranscriptions && !this.sentByCurrentUser(message.senderId)) {
            // console.log('Notifying sender');
            if (!document.hasFocus()) {
                console.log('Notifying receiver: Message from ' + message.senderId);
                let promise = this.messageReceivedAudio.play().catch(reason => {
                    console.warn("Message received audio cannot be played:" + reason);
                });
            }
            else {
                console.log('No need to notify anyone. But the message is from ' + message.senderId);
            }
            this.unreadMessageCount++;
            this.unreadMessageCountChange.emit(this.unreadMessageCount);
            this.scrolledToBottom.emit({ userId: this.userId, coachId: this.coachId, unreadMessageCount: this.unreadMessageCount });
            setTimeout(() => { this.messageService.messageSeen(message.id).subscribe(); }, 500);
        }
        else {
            this.cdkScrollToBottom();
        }
    }
    updateMessageStatus(messageId) {
        // The last message status is updated to DISPLAYED before this event, so I include that one by adding 1. This needs to be revisited and the true cause needs to be found and fixed.
        this.messageRepository.updateToDisplayedStatus(messageId);
    }
    checkOverflow(element) {
        return element.offsetHeight > 60;
    }
    ngOnDestroy() {
        var _a, _b, _c, _d;
        (_a = this.subscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.scrollElementEventSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.authenticatedUserSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.eventManagerSubscription) === null || _d === void 0 ? void 0 : _d.unsubscribe();
    }
    initCreateDate(m) {
        m.createDate = moment(m.createDate);
        return m;
    }
    isFirstSessionMessage(m, i) {
        return false;
    }
    isScrolledIntoView(element) {
        if (element != null && element.getBoundingClientRect != null) {
            let rect = element.getBoundingClientRect();
            let elemTop = rect.top;
            let elemBottom = rect.bottom;
            return (elemTop >= this.virtualTop) && (elemBottom <= this.virtualBottom);
        }
        else {
            return false;
        }
    }
    onKeyupHandler(event) {
        this.isKeyPressed = true;
    }
    onMessageReactionUpdated(reaction) {
        this.messageRepository.updateReaction(reaction.messageId, reaction.receiverReaction);
    }
    updateMessageReaction(message, reaction) {
        const messageReaction = new MessageReactionDto(message.id, reaction);
        this.messageService.updateMessageReaction(messageReaction).subscribe();
    }
    removeMessageReaction(message) {
        var _a;
        // if the current user is the message receiver it means the message reaction belongs to the current user
        if (message.receiverId === ((_a = this.currentAccount) === null || _a === void 0 ? void 0 : _a.id) && message.receiverReaction) {
            const reaction = null; // set reaction to null to remove the reaction
            this.updateMessageReaction(message, reaction);
        }
    }
    updateSize() {
        setTimeout(() => {
            this.virtualScroll.dataSource.adapter.check().then();
        }, 500);
    }
    getMessageColor(m) {
        var _a;
        if (this.isSupervisor() || this.isMastermind())
            return m.senderId === this.session.user.id ? 'right' : 'left';
        else
            return m.senderId === ((_a = this.currentAccount) === null || _a === void 0 ? void 0 : _a.id) ? 'right' : 'left';
    }
    showExternalVideoCallPopup(redirectUrl) {
        const userId = this.currentAccount.id;
        const modalRef = this.modalService.open(ExternalVideoCallRedirectPopupComponent, { size: "lg" });
        modalRef.componentInstance.redirectUrl = redirectUrl;
        modalRef.componentInstance.userId = userId;
    }
}
ChatUiNewComponent.ɵfac = function ChatUiNewComponent_Factory(t) { return new (t || ChatUiNewComponent)(i0.ɵɵdirectiveInject(i6.AuthServerProvider), i0.ɵɵdirectiveInject(i7.MessageService), i0.ɵɵdirectiveInject(i8.JhiEventManager), i0.ɵɵdirectiveInject(i3.TrackerService), i0.ɵɵdirectiveInject(i9.DomSanitizer), i0.ɵɵdirectiveInject(i1.AccountService), i0.ɵɵdirectiveInject(i2.SessionStorageService), i0.ɵɵdirectiveInject(i4.NgbModal), i0.ɵɵdirectiveInject(i5.JhiLanguageService), i0.ɵɵdirectiveInject(i10.Router), i0.ɵɵdirectiveInject(i11.ConversationnService), i0.ɵɵdirectiveInject(i12.RatingService), i0.ɵɵdirectiveInject(i13.SessionService), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i14.VideoCallService)); };
ChatUiNewComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ChatUiNewComponent, selectors: [["chat-ui-new"]], viewQuery: function ChatUiNewComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c4, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.consentToShareOrganizationResourcesModal = _t.first);
    } }, hostBindings: function ChatUiNewComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("keyup", function ChatUiNewComponent_keyup_HostBindingHandler($event) { return ctx.onKeyupHandler($event); }, false, i0.ɵɵresolveDocument);
    } }, inputs: { session: "session", displayingPastSession: "displayingPastSession", selectedConversation: "selectedConversation", showInModal: "showInModal", viewportHeight: "viewportHeight", displayTranscriptions: "displayTranscriptions", isMessageReactionsEnabled: "isMessageReactionsEnabled" }, outputs: { repliedMessage: "repliedMessage", firstSessionMessageOutput: "firstSessionMessageOutput" }, features: [i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature], decls: 11, vars: 5, consts: [[1, "chat-ui-new", "olha-theme"], ["messagesContainer", ""], ["style", "position: absolute;top:5px;text-align: center;z-index: 1000;width: 100%;", "jhiTranslate", "sessionChat.messages.loading", 4, "ngIf"], ["id", "top-date", "class", "top-date-sticky badge badge-secondary", 4, "ngIf"], [3, "height", 4, "ngIf"], ["class", "notification-div-messages text-center selected-messages-to-email-container", 4, "ngIf"], ["class", "position-relative float-right", "style", "right: 55px; bottom: 10px; z-index: 1000", 4, "ngIf"], ["consentToShareOrganizationResourcesModal", ""], ["organizationResourcesModal", ""], ["jhiTranslate", "sessionChat.messages.loading", 2, "position", "absolute", "top", "5px", "text-align", "center", "z-index", "1000", "width", "100%"], ["id", "top-date", 1, "top-date-sticky", "badge", "badge-secondary"], ["topDate", ""], ["virtualScrollViewPortContainer", ""], [1, "virtual-scroll-viewport-container", "scrollable", 3, "ngStyle"], [4, "uiScroll", "uiScrollOf"], ["virtualScrollViewPort", ""], ["id", "messages", 1, "position-relative", 3, "ngStyle"], ["messageBox", ""], ["class", "d-flex justify-content-center position-relative m-3", 4, "ngIf"], [2, "margin-bottom", "5px"], [1, "date-sticky", "badge"], ["class", "notification-div text-center", 4, "ngIf"], ["class", "message-feed chat-message-container", 3, "id", "ngClass", "mouseenter", "mouseleave", 4, "ngIf"], [1, "d-flex", "justify-content-center", "position-relative", "m-3"], [1, "session-separator", "align-self-center", 2, "width", "90%"], ["jhiTranslate", "inukaNgApp.offlineMessage.Session Ended", 1, "message-text", "message-header"], ["jhiTranslate", "inukaNgApp.offlineMessage.Session Started", 1, "message-text", "message-header"], [1, "notification-div", "text-center"], [3, "innerHtml", "applyAlignment", "isAutomatedMessage"], [3, "jhiTranslate"], [4, "ngIf"], ["class", "notification-link", "jhiTranslate", "inukaNgApp.inukaJourney.bookFollowUpSession", 3, "routerLink", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.inukaJourney.bookFollowUpSession", 1, "notification-link", 3, "routerLink"], [1, "btn", "btn-primary", 3, "click"], ["jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedCoachBeforeLink"], ["jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedCoachLink", 1, "notification-link", 3, "click"], ["jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedCoachAfterLink"], ["jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedUserBeforeLink"], ["target", "_blank", "jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedUserLink", "routerLink", "/organization-resources", 1, "notification-link"], ["jhiTranslate", "inukaNgApp.inukaJourney.dataSharingAccessGrantedUserAfterLink"], [1, "message-feed", "chat-message-container", 3, "id", "ngClass", "mouseenter", "mouseleave"], [1, "media-body", 2, "position", "relative", 3, "click"], ["class", "selected-icon selected-icon-left", 4, "ngIf"], [1, "mf-content", 2, "text-align", "left", "display", "inline-block"], ["style", "font-weight: bold; font-size: 16px;", 4, "ngIf"], ["class", "reply-div", 3, "ngSwitch", 4, "ngIf"], [3, "id", "ngSwitch"], ["messageElement", ""], [4, "ngSwitchCase"], ["class", "d-none", 4, "ngSwitchCase"], [4, "ngSwitchDefault"], [3, "click"], [1, "message-reaction-emoji"], [1, "message-reaction-remove"], [2, "height", "15px", "width", "14px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#trash-bin"], ["class", "selected-icon selected-icon-right", 4, "ngIf"], [1, "selected-icon", "selected-icon-left"], ["class", "check-icon-div", 3, "ngStyle", "title", "click", 4, "ngIf"], ["class", "reply-icon-div reply-message-btn", 3, "title", "click", 4, "ngIf"], [1, "check-icon-div", 3, "ngStyle", "title", "click"], ["class", "check-icon", "icon", "check", 4, "ngIf"], ["icon", "check", 1, "check-icon"], [1, "reply-icon-div", "reply-message-btn", 3, "title", "click"], ["icon", "reply", 1, "reply-icon"], [2, "font-weight", "bold", "font-size", "16px"], [1, "reply-div", 3, "ngSwitch"], ["role", "button", "style", "max-height: fit-content", 3, "click", 4, "ngSwitchCase"], ["role", "button", "style", "max-height: 60px", 3, "click", 4, "ngSwitchDefault"], ["role", "button", 2, "max-height", "fit-content", 3, "click"], [3, "href"], ["alt", "", 1, "img-chat", 3, "src"], [3, "innerHtml"], ["role", "button", 2, "max-height", "60px", 3, "click"], [2, "width", "95%"], ["overflow", ""], ["class", "ellipsis-text", 4, "ngIf"], [1, "ellipsis-text"], ["controls", ""], ["type", "audio/mpeg", 3, "src"], ["target", "_blank", 3, "href"], [1, "d-none"], [1, "message-text"], [3, "innerHtml", "isAutomatedMessage"], [1, "float-right", "message-time"], ["alt", "", 3, "src", 4, "ngIf"], ["alt", "", 3, "src"], [1, "selected-icon", "selected-icon-right"], [1, "reply-icon-div", 3, "title", "click"], [3, "message", "onReactionSelected", 4, "ngIf"], [3, "message", "onReactionSelected"], [1, "notification-div-messages", "text-center", "selected-messages-to-email-container"], ["jhiTranslate", "inukaNgApp.offlineMessage.messageSelected", 3, "translateValues", 4, "ngIf"], ["jhiTranslate", "inukaNgApp.offlineMessage.messagesSelected", 3, "translateValues", 4, "ngIf"], [1, "send-email-icon"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#send-email"], ["id", "email-selected-messages-btn", "jhiTranslate", "inukaNgApp.offlineMessage.sendToUser", 1, "notification-link", 3, "click"], ["role", "button", "icon", "times-circle", 1, "message-list-empty", 3, "click"], ["jhiTranslate", "inukaNgApp.offlineMessage.messageSelected", 3, "translateValues"], ["jhiTranslate", "inukaNgApp.offlineMessage.messagesSelected", 3, "translateValues"], [1, "position-relative", "float-right", 2, "right", "55px", "bottom", "10px", "z-index", "1000"], [1, "scroll-down", 3, "click"], [1, "arrow-down-image", 2, "width", "1rem!important", "height", "0.5rem!important"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#arrow-down"], ["class", "badge-pill", 4, "ngIf"], [1, "badge-pill"], [1, "olha-theme", "resources-content"], [1, "d-flex", "justify-content-end", "pt-2", "pr-2"], ["icon", "times-circle", 1, "close-icon", 3, "click"], [1, "modal-body", "bg-white", "p-3"], [1, "modal-div"], [3, "userId", "isRequest"], [3, "userId", "isPopup"]], template: function ChatUiNewComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0, 1);
        i0.ɵɵtemplate(2, ChatUiNewComponent_div_2_Template, 2, 0, "div", 2);
        i0.ɵɵtemplate(3, ChatUiNewComponent_div_3_Template, 3, 1, "div", 3);
        i0.ɵɵtemplate(4, ChatUiNewComponent_div_4_Template, 4, 6, "div", 4);
        i0.ɵɵtemplate(5, ChatUiNewComponent_div_5_Template, 7, 2, "div", 5);
        i0.ɵɵtemplate(6, ChatUiNewComponent_div_6_Template, 5, 1, "div", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(7, ChatUiNewComponent_ng_template_7_Template, 6, 2, "ng-template", null, 7, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(9, ChatUiNewComponent_ng_template_9_Template, 6, 2, "ng-template", null, 8, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.isFetchingMessages);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.virtualScroll && ctx.firstVisibleMessage);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.virtualScroll);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.messagesList != null && ctx.messagesList.length != 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.hasHiddenMessages);
    } }, directives: [i15.NgIf, i16.JhiTranslateDirective, i15.NgStyle, i17.UiScrollDirective, i18.AutoDirectionSwitchComponent, i10.RouterLink, i10.RouterLinkWithHref, i15.NgClass, i15.NgSwitch, i15.NgSwitchCase, i15.NgSwitchDefault, i19.FaIconComponent, i20.MessageReactionSelectorComponent, i21.ConsentToShareOrganizationResourceComponent, i22.OrganizationResourcesComponent], pipes: [i23.TranslatePipe], styles: [".chat-ui-new[_ngcontent-%COMP%]{overflow:hidden !important;position:relative !important;height:100% !important}.message-feed[_ngcontent-%COMP%]{padding-top:0 !important;padding-bottom:0 !important}.message-feed.right[_ngcontent-%COMP%]{text-align:right;position:relative;padding-right:30px !important}.message-feed.right[_ngcontent-%COMP%]   .mf-content[_ngcontent-%COMP%]{background:#f7f4eb !important;border-radius:6px 0 6px 6px !important;min-width:15rem;margin-bottom:1rem}.message-feed.right[_ngcontent-%COMP%]   .mf-content[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;right:-10px;border-top:10px solid #f7f4eb;border-bottom:10px solid transparent;border-right:10px solid transparent;z-index:100}.message-feed.left[_ngcontent-%COMP%]{padding-left:30px !important}.message-feed.left[_ngcontent-%COMP%]   .mf-content[_ngcontent-%COMP%]{background:#cce9e0 !important;border-radius:0 6px 6px 6px !important;min-width:15rem;margin-bottom:1rem}.message-feed.left[_ngcontent-%COMP%]   .mf-content[_ngcontent-%COMP%]:before{content:\"\";position:absolute;top:0;left:-10px;border-top:10px solid #cce9e0;border-bottom:10px solid transparent;border-left:10px solid transparent;z-index:100}.message-reaction[_ngcontent-%COMP%]{position:absolute;font-size:1.3rem;bottom:-8px;background-color:#fff;height:2.1rem;width:2.1rem;text-align:center;border-radius:50%;z-index:5;box-shadow:0 0 .2rem rgba(108,118,134,.32)}.message-reaction-remove[_ngcontent-%COMP%]{display:none}.message-feed.right[_ngcontent-%COMP%]   .message-reaction[_ngcontent-%COMP%]{right:15px}.message-feed.left[_ngcontent-%COMP%]   .message-reaction[_ngcontent-%COMP%]{left:15px;cursor:pointer}.message-feed.left[_ngcontent-%COMP%]   .message-reaction[_ngcontent-%COMP%]:hover   .message-reaction-emoji[_ngcontent-%COMP%]{display:none}.message-feed.left[_ngcontent-%COMP%]   .message-reaction[_ngcontent-%COMP%]:hover   .message-reaction-remove[_ngcontent-%COMP%]{display:inline}.msb-reply[_ngcontent-%COMP%]{box-shadow:0 -20px 20px -5px #fff;background:#fff}.scroll-down[_ngcontent-%COMP%]{position:absolute;bottom:10px;border:0;font-size:20px;background:#fff !important;color:#44a38d !important;height:40px;width:40px;border-radius:50%;box-shadow:2px 2px 8px -4px rgba(0,0,0,.75)}.scroll-down[_ngcontent-%COMP%]:hover{background-color:#fafaff}.img-chat[_ngcontent-%COMP%]{float:left;width:150px;height:150px;-o-object-fit:cover;object-fit:cover}.message-text[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;font-size:14px !important;word-break:break-word}.message-header[_ngcontent-%COMP%]{color:#7cbfae !important;background:#fff !important;position:absolute;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);padding:0 1rem;z-index:100 !important}.session-separator[_ngcontent-%COMP%]{border-top:1px solid #7cbfae !important}.message-time[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;font-size:12px !important;margin:15px 0 0 8px !important}.reply-div[_ngcontent-%COMP%]{font-size:12px !important;background-color:#fff !important;border-radius:3px;text-align:left;margin:0 3px 0 3px;padding:2px;word-break:break-word;overflow:hidden;position:relative}.ellipsis-text[_ngcontent-%COMP%]{position:absolute;top:38px;right:-46px;width:20%}.notification-link[_ngcontent-%COMP%]{color:#44a38d;font-weight:bold;text-decoration:underline;cursor:pointer;margin-left:5px}.send-email-icon[_ngcontent-%COMP%]{height:12px;width:16px;margin-left:15px}.message-list-empty[_ngcontent-%COMP%]{float:right;margin-right:20px;color:#8a9d98}.component-header[_ngcontent-%COMP%]{padding:10px 20px 0 20px;text-transform:uppercase;font-weight:bold;color:#000}.virtual-scroll-viewport-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;padding-top:10px;padding-left:10px;padding-bottom:20px}.scrollable[_ngcontent-%COMP%]{overflow-y:scroll}#virtual-scroll-viewport[_ngcontent-%COMP%]{flex-grow:1;overflow-x:hidden}.minus-90[_ngcontent-%COMP%]{height:calc(100% - 60px) !important}.minus-80[_ngcontent-%COMP%]{height:calc(100% - 80px) !important}.minus-30[_ngcontent-%COMP%]{height:calc(100% - 30px) !important}.minus-10[_ngcontent-%COMP%]{height:calc(100% - 10px) !important}#messages[_ngcontent-%COMP%]{width:100%}.badge[_ngcontent-%COMP%]{background:#f7eed2 !important;color:#8a9d98 !important;border-radius:16px !important;padding:1px 24px !important}.badge-pill[_ngcontent-%COMP%]{font-family:\"Open Sans\",sans-serif !important;background:#44a38d !important;color:#fff !important;border-radius:50% !important;position:absolute !important;top:-12px !important;left:10px !important;padding:0 !important;height:20px !important;width:20px !important;font-size:12px !important}.date-sticky[_ngcontent-%COMP%]{position:-webkit-sticky;top:0;display:table;margin:0 auto;width:105px}.v-hidden[_ngcontent-%COMP%]{visibility:hidden}.top-date-sticky[_ngcontent-%COMP%]{position:-webkit-sticky;top:6px;display:table;margin:0 auto;width:105px;position:sticky;z-index:99}.rating-stars[_ngcontent-%COMP%]   .rating-stars-container[_ngcontent-%COMP%]   .rating-star[_ngcontent-%COMP%]{font-size:22px !important;padding:0 6px !important;color:#fff}.rating-star-hover[_ngcontent-%COMP%]{color:#44a38d}.star-icon[_ngcontent-%COMP%]{stroke:#44a38b;stroke-width:2}.feedback-text[_ngcontent-%COMP%]{text-decoration:underline !important;color:#44a38b !important;cursor:pointer !important;font-size:14px !important;margin:0 !important}[_nghost-%COMP%] .feedback-tool-tip{color:#fff !important;background:#44a38b !important;border:1px solid #44a38b !important;overflow:visible !important}[_nghost-%COMP%]  .feedback-tool-tip:before{content:\"\";position:absolute;top:-11px;left:50%;border-bottom:10px solid #44a38b;border-left:10px solid transparent;border-right:10px solid transparent;z-index:100}.img-chat[_ngcontent-%COMP%]{float:left;width:150px;height:150px;-o-object-fit:cover;object-fit:cover}.hello-message[_ngcontent-%COMP%]{margin:0 auto}.check-icon-div[_ngcontent-%COMP%]{border:1px solid #44a38b;border-radius:4px;width:19px;height:19px;position:relative;cursor:pointer;margin-bottom:5px}.check-icon[_ngcontent-%COMP%]{color:#fff;font-size:15px;position:absolute;top:-2px;left:1px}.reply-icon-div[_ngcontent-%COMP%]{border:1px solid #fff;width:19px;height:19px;position:relative;cursor:pointer}.reply-icon[_ngcontent-%COMP%]{color:#44a38b;font-size:15px;position:absolute;top:-2px;left:1px}.notification-div[_ngcontent-%COMP%]{background:#f7eed2;border-radius:0;padding-top:10px;padding-bottom:10px;margin-top:25px;margin-bottom:25px}.notification-div-messages[_ngcontent-%COMP%]{background:#f7eed2;border-radius:0;padding-top:10px;margin-top:25px;padding-bottom:10px;margin-bottom:15px}.resources-content[_ngcontent-%COMP%]{padding:20px}[_nghost-%COMP%]  .cdk-virtual-scroll-content-wrapper{max-width:100%}.selected-messages-to-email-container[_ngcontent-%COMP%]{position:absolute;top:0;left:0;width:100%;z-index:1000;margin:0}@media(min-width: 768px){.minus-90[_ngcontent-%COMP%]{height:calc(100% - 90px) !important}.your-session-started-header[_ngcontent-%COMP%]{margin:16px 30px 20px 30px !important;border-radius:10px !important}.your-session-started-text[_ngcontent-%COMP%]{padding:16px !important;font-size:14px !important}.session-started-text[_ngcontent-%COMP%]{padding:7px !important;font-size:14px !important}}"] });
